import { request } from './httpClient';

// ACON-60: read-only, account-scoped invoices sourced from AvSight Core.
export function getInvoices(params) {
  return request({ method: 'GET', url: '/v1/invoices', params });
}
